import React, { useEffect, useState } from 'react';
import AssessmentCard, { AssessmentCardProps } from './AssessmentCard';
import { Button, Grid } from '@mui/material';
import APICaller, { MethodType } from '../common/APICaller';
import { useNavigate } from 'react-router-dom';
import CustomizedModal from '../common/CustomizedModal';

interface AssessmentCardsProps {
  jobId: string | undefined;
  filterType?: 'required' | 'optional';
  showSubmit?: boolean;
}

const AssessmentCards: React.FC<AssessmentCardsProps> = ({ jobId, filterType = 'required', showSubmit = true }) => {
  const [data, setData] = useState<(AssessmentCardProps & { isOptional?: boolean | number })[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const required = data.filter(d => !d.isOptional);
  const optional = data.filter(d => !!d.isOptional);
  // Combine into a single list (required first, then optional)
  const listToRender = [...required, ...optional];
  const completedRequiredCount = required.filter(d => d.isComplete).length;
  const navigate = useNavigate();
  useEffect(() => {
    // TODO: fetch data based on JWT
    APICaller(`/application/jobs/${jobId}/assessments`, MethodType.GET).then(
      res => {
        console.log(res);
        if (!res.errorMessage) {
          setData(res);
        }
      },
    );
  }, [jobId]);
  const submitApplicationHandler = () => {
  const allRequiredDone = required.every(r => !!r.isComplete);
  if (allRequiredDone) {
      APICaller(`/application/jobs/${jobId}/submit`, MethodType.PUT)
        .then(res => {
          console.log(res);
          if (!res.errorMessage) {
            navigate('/applications');
          }
        })
        .catch(e => {
          console.log(e);
        });
    } else {
      setOpenModal(true);
    }
  };

  const modalClickHander = () => {
    setOpenModal(false);
  };
  const SubmitButton = (
    <Button
      variant="contained"
      sx={{
        width: '30%',
        backgroundColor: 'var(--ttg-green)',
        '&:hover': {
          backgroundColor: 'var(--ttg-green)',
        },
      }}
      disabled={required.length > 0 && completedRequiredCount < required.length}
      onClick={submitApplicationHandler}
    >
      {required.length === 0 ? 'Express Interest' : 'Submit Job Application'}
    </Button>
  );
  // If this instance is only for listing (no submit) and there's nothing to show, render nothing
  if (!showSubmit && listToRender.length === 0) return null;
  // If there are no assessments but we still want submit/express interest, render heading + button
  if (showSubmit && listToRender.length === 0) {
    return (
      <Grid container flexDirection={'column'} alignItems={'center'}>
        {SubmitButton}
      </Grid>
    );
  }
  return (
    <Grid container flexDirection={'column'} alignItems={'center'}>
      {listToRender.map(d => {
        return (
          <AssessmentCard
            key={d.id}
            id={d.id}
            title={d.title}
            isComplete={d.isComplete}
            isStarted={d.isStarted}
            isOptional={d.isOptional}
            jobId={jobId}
          />
        );
      })}
      {showSubmit && (required.length > 0 || optional.length > 0) && SubmitButton}
      {showSubmit && (
        <CustomizedModal
        open={openModal}
        title={'Warning'}
        description={'Please complete all required assessment(s) before submitting!'}
        buttonText={'I See!'}
        clickHandler={modalClickHander}
        />
      )}
    </Grid>
  );
};

export default AssessmentCards;
